import { Box, StyleProps } from "@chakra-ui/react";
import React from "react";

import { useFontVariantNumericStrategy } from "../../hooks/useFontVariantNumericStrategy";

type MonospacedTextProps = {
  text: string;
} & StyleProps;

const MonospacedText: React.FC<MonospacedTextProps> = ({ text, ...styles }) => {
  useFontVariantNumericStrategy();
  const fontVariant = {
    strategy: window.fvStrategy,
    width: window.fvWidth,
  };
  // If there's no text, no care
  if (!text) {
    return <span />;
  }
  // If we should use the span strategy, put each character in its own span :(
  if (fontVariant.strategy === "span") {
    const chars = [...text];
    return (
      <Box as="span" {...styles} whiteSpace="nowrap">
        {chars.map((char, i) => {
          return (
            <span
              style={{
                display: "inline-block",
                width: fontVariant.width ?? "0.7em",
                textAlign: "center",
              }}
              key={`mono-char-${i + 1}`}
            >
              {char}
            </span>
          );
        })}
      </Box>
    );
  }
  // Otherwise, use tabular-nums :)
  return (
    <Box
      {...styles}
      whiteSpace="nowrap"
      style={{ fontVariantNumeric: "tabular-nums" }}
    >
      {text}
    </Box>
  );
};

export default MonospacedText;
